import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog'

class ForgotPasswordPrompt extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const actions = [
      <RaisedButton label="Submit" primary={true} disabled={this.props.submitting} onClick={this.handleSubmit} />
    ];
    return (
      <Dialog open={this.props.open} title="Reset Password" onRequestClose={this.props.onRequestClose} actions={actions}>
        We have sent a code to {this.props.email}. Please provide it along with a new password of your choosing.
        <br />
        <TextField
          autoFocus
          ref="code"
          floatingLabelText="Code"
          defaultValue={this.props.code}
          type="text"
        />
        <br />
        <TextField
          ref="password"
          floatingLabelText="New Password"
          type="password"
          defaultValue={this.props.password}
          onKeyDown={this.handleKeyDown}
        />
        { this.props.error ? <div style={{color: "red", marginTop: 20}}>{this.props.error}</div> : null}
      </Dialog>
    )
  }

  handleSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit(
        this.refs.code.getValue(),
        this.refs.password.getValue()
      )
    }
  }

}

ForgotPasswordPrompt.defaultProps = {
  open: false
}

export default ForgotPasswordPrompt
